import React from 'react';
import '../assets/css/Services.css';

// وضعنا البيانات هنا لتسهيل إدارتها
const servicesData = [
  {
    icon: 'fa-laptop',
    title: 'تطوير تطبيقات الويب',
    description: 'نُقدّم خدمات مخصصة لتطوير تطبيقات الويب تشمل الواجهة الأمامية والخلفية. سواء كنت ترغب في تحسين تطبيق موجود أو بناء تطبيق مؤسسي متكامل، فريقنا جاهز للتحدي.'
  },
  {
    icon: 'fa-mobile-alt', // أيقونة أفضل للجوال
    title: 'تطوير تطبيقات الهواتف',
    description: 'نمتلك خبرة في إنشاء تطبيقات متعددة المنصات تعمل على أجهزة Android و iOS باستخدام أحدث التقنيات لتقديم تجربة سلسة ومخصصة للمستخدم.'
  },
  {
    icon: 'fa-bullhorn', // أيقونة أفضل للتسويق
    title: 'التسويق الرقمي',
    description: 'نُقدّم خدمات تسويق رقمي متكاملة تُساعد على زيادة الظهور الإلكتروني، والتفاعل مع العملاء على مختلف المنصات الرقمية بفعالية واحترافية.'
  }
];

function Services() {
  return (
    <section className="services-section" id="service">
      <div className="services-container">
        <div className="services-title-wrapper">
          <h1 className="services-title">خدماتنا</h1>
          <p className="services-subtitle">
            نساعدك في بناء حلول رقمية عالية الجودة، وتقديم مجموعة واسعة من الخدمات الاحترافية لنقل أعمالك إلى مستوى جديد.
          </p>
        </div>

        <div className="services-grid">
          {/* نستخدم .map() هنا لعرض الخدمات بشكل ديناميكي */}
          {servicesData.map((service, index) => (
            <div className="service-card" key={index}>
              <div className="service-icon">
                <i className={`fa ${service.icon}`}></i>
              </div>
              <h3 className="service-card-title">{service.title}</h3>
              <p className="service-card-description">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Services;